import { Injectable } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormArray,
  UntypedFormControl,
} from '@angular/forms';
import { IPurchasesInvoices } from '../../../../../@interfaces/purchaseInvoice.interface';
import { IProvider } from 'src/app/@interfaces/provider.interface';

@Injectable({
  providedIn: 'root',
})
export class ModifyPurchaseService {
  constructor() {}

  setQuotationData(
    purchaseForm: UntypedFormGroup,
    rowsArr: UntypedFormArray,
    newProvider: UntypedFormControl,
  ) {
    let setPurchaseInvoice = {} as IPurchasesInvoices;
    var total: number = 0;
    const formValue = purchaseForm.getRawValue();
    setPurchaseInvoice.tax = formValue.tax;
    setPurchaseInvoice.provider = {} as IProvider;
    setPurchaseInvoice.provider.id_provider = parseInt(
      newProvider.value.id_provider,
    );
    setPurchaseInvoice.createdAt = formValue.date;
    setPurchaseInvoice.dueDate = formValue.dueDate;
    setPurchaseInvoice.tax_incl = new Boolean(formValue.tax_include).toString();
    setPurchaseInvoice.clause = new Boolean(formValue.clause).toString();
    setPurchaseInvoice.contpurchase = { written_invoice: '' };
    setPurchaseInvoice.contpurchase!.written_invoice =
      formValue.written_invoice;
    setPurchaseInvoice.is_electronic_document =
      formValue.is_electronic_document;
    for (let x = 0; x < rowsArr.value.length; x++) {
      total = total + parseFloat(rowsArr.value[x].subtotal);
    }
    setPurchaseInvoice.purchases = [
      {
        id_purchases: [],
        id_warehouse: [],
        codigo: [],
        quantity: [],
        price: [],
        discount: [],
        subtotal: [],
        total: [],
        id_article: [],
        id_purchase_unit: [],
        quantity_in_base_unit: [],
      },
    ];
    for (let index = 0; index < rowsArr.value.length; index++) {
      if (rowsArr.value[index].ids) {
        setPurchaseInvoice.purchases[0].id_purchases.push(
          parseInt(rowsArr.value[index].ids),
        );
      }
      setPurchaseInvoice.purchases[0].id_warehouse.push(
        parseInt(rowsArr.value[index].warehouse.id_almacen),
      );
      setPurchaseInvoice.purchases[0].codigo.push(
        rowsArr.value[index].article.codigo,
      );
      setPurchaseInvoice.purchases[0].quantity.push(
        parseFloat(rowsArr.value[index].quantity),
      );
      setPurchaseInvoice.purchases[0].price.push(
        parseFloat(rowsArr.value[index].price),
      );
      setPurchaseInvoice.purchases[0].discount.push(
        parseFloat(rowsArr.value[index].discount),
      );
      setPurchaseInvoice.purchases[0].subtotal.push(
        parseFloat(rowsArr.value[index].subtotal),
      );
      setPurchaseInvoice.purchases[0].total.push(total);
      setPurchaseInvoice.purchases[0].id_article.push(
        rowsArr.value[index].article.id_articulo,
      );

      // Always push values to maintain array index consistency
      const purchaseUnitValue = rowsArr.value[index].unit
        ? parseInt(rowsArr.value[index].unit)
        : null;
      setPurchaseInvoice.purchases[0].id_purchase_unit!.push(
        purchaseUnitValue as any,
      );

      const quantityInBaseUnitValue = rowsArr.value[index].quantityInBaseUnit
        ? parseFloat(rowsArr.value[index].quantityInBaseUnit)
        : parseFloat(rowsArr.value[index].quantity); // Fallback to quantity if not set
      setPurchaseInvoice.purchases[0].quantity_in_base_unit!.push(
        quantityInBaseUnitValue as any,
      );
    }

    return setPurchaseInvoice;
  }
}
